(() => {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const bodyOpenClass = 'hedera-mobile-menu-open';
  const drawerSelector = 'header-drawer';
  const mainDetailsSelector = '#Details-menu-drawer-container';

  function drawerRoots() {
    return Array.from(document.querySelectorAll(drawerSelector));
  }

  function getDetails(root) {
    return root.querySelector(mainDetailsSelector) || root.querySelector(':scope > details');
  }

  function isAnyDrawerOpen() {
    return drawerRoots().some((root) => getDetails(root)?.open);
  }

  function syncBodyState() {
    document.body.classList.toggle(bodyOpenClass, mobileQuery.matches && isAnyDrawerOpen());
  }

  function resetDrawer(root) {
    const details = getDetails(root);
    if (!details) return;

    details.querySelectorAll('details').forEach((nestedDetails) => {
      nestedDetails.open = false;
      nestedDetails.classList.remove('menu-opening');
      nestedDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });

    details.querySelectorAll('.submenu-open').forEach((element) => {
      element.classList.remove('submenu-open');
    });

    details.open = false;
    details.classList.remove('menu-opening');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    root.closest('.section-header')?.classList.remove('menu-open');
  }

  function bindDrawer(root) {
    if (root.dataset.hederaStateBound === 'true') return;
    root.dataset.hederaStateBound = 'true';

    const details = getDetails(root);
    if (!details) return;

    details.addEventListener('toggle', syncBodyState);
  }

  function bindAll() {
    drawerRoots().forEach(bindDrawer);
    syncBodyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  // Shopify's theme preview and mobile Safari can restore an open <details>
  // element from the back-forward cache. Reset it before it can expose header
  // controls through a stale drawer state.
  window.addEventListener('pageshow', () => {
    drawerRoots().forEach(resetDrawer);
    document.body.classList.remove(
      bodyOpenClass,
      'overflow-hidden-tablet',
      'overflow-hidden-mobile',
      'overflow-hidden-desktop'
    );
    bindAll();
  });

  mobileQuery.addEventListener?.('change', syncBodyState);
})();
